import { Stack, Typography } from "@mui/material";
import _ from "lodash";

const Content = ({ medicalDocument, truncated, isTooltip }) => {
  const { medicines } = medicalDocument;
  const medicinesToShow = _.isEmpty(medicines)
    ? [{ text: medicalDocument.medicine }]
    : medicines;

  return (
    <Stack>
      {_.map(medicinesToShow, ({ text, longTerm }, index) => (
        <Stack key={index}>
          <Typography
            sx={{
              color: isTooltip ? "text.white" : "text.black",
              fontFamily: "'Inter', sans-serif",
              wordBreak: "break-word",
            }}
          >
            {truncated ? _.truncate(text, 30) : text}
          </Typography>
          {longTerm && <Typography>Tratamiento prolongado</Typography>}
        </Stack>
      ))}
    </Stack>
  );
};

export default Content;